import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { IGetCodes } from 'src/app/interfaces/codes';
import {
  IGetQuestionRelationshipResponse,
  IGroup,
  IQuestionRelationship,
  IQuestionsWithAnswersModifiedResponse,
} from 'src/app/interfaces/questionManagement';
import { QuestionManagementService } from 'src/app/Services/question-management.service';
import {
  CdkDragDrop,
  CdkDragEnter,
  CdkDragMove,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import { ConstantVars } from 'src/app/utils/constants/constants';

@Component({
  selector: 'app-shuffling-question-modal',
  templateUrl: './shuffling-question-modal.component.html',
  styleUrls: ['./shuffling-question-modal.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ShufflingQuestionModalComponent implements OnInit {
  @Input() SubjectId: number;
  @Input() QuestionId: string | null;
  @Input() ScreenName: string;
  @Input() filter: string = '';
  @Output() openQuestionEdit = new EventEmitter<any>(); // Define EventEmitter

  Questions: IQuestionsWithAnswersModifiedResponse[] = [];
  Groups: IGroup[] = [];
  initialValueGroup: IGroup;
  selectedGroup: IGroup;
  @ViewChild('dropListContainer') dropListContainer?: ElementRef;
  dropListReceiverElement?: HTMLElement;
  dragDropInfo?: {
    dragIndex: number;
    dropIndex: number;
  };
  droppedIndex: number | null;
  displayOrder: boolean = false;
  path: string;

  constructor(
    public activeModal: NgbActiveModal,
    public questionService: QuestionManagementService,
    private sanitizer: DomSanitizer,
    private readonly toaster: ToastrService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    const payloadGetquestions = {
      SubjectId: this.SubjectId,
      QuestionId: this.QuestionId,
      ScreenName: this.ScreenName,
      QuestionStatusTypeCode: this.filter,
    };
    const pathPayload = {
      SubjectId: this.SubjectId,
      Screenname: this.ScreenName,
    };
    forkJoin([
      this.questionService.getQuestionAndAnswers$(payloadGetquestions),
      this.questionService.getPath$(pathPayload),
    ]).subscribe(
      ([question, path]) => {
        this.path = path;
        this.Questions = question;
        console.log(this.Questions);
        this.droppedIndex = null;
        this.displayOrder = this.Questions.some((e) => e.Display_Order);
        this.sortQuestions();
      },
      (error) => {
        // Handle errors gracefully
        console.error('Error fetching questions:', error);
        this.toaster.error('Failed to load questions. Please try again later.');
      }
    );
  }
  sortQuestions() {
    const allNull = this.Questions.every((q) => q.Display_Order === null);
    if (allNull) {
      // Do nothing if all values are null
      return;
    }

    this.Questions.sort((a, b) => {
      // If both are null, maintain original order
      if (a.Display_Order === null && b.Display_Order === null) {
        return 0;
      }

      // If one is null, place it after the one with a value
      if (a.Display_Order === null) {
        return 1;
      }
      if (b.Display_Order === null) {
        return -1;
      }

      // Otherwise, sort by ascending Display_Order
      return a.Display_Order - b.Display_Order;
    });
  }
      printQuestionDetails(question:IQuestionsWithAnswersModifiedResponse) {
    const arr = question.previouslyAppearedDescriptions ;
    const str = arr.join(", ");
    return str ? '('+str+')' :'' ;
  }
  getQuestionsAndAnswers() {
    const payloadGetquestions = {
      SubjectId: this.SubjectId,
      QuestionId: this.QuestionId,
      ScreenName: this.ScreenName,
    };
    this.questionService
      .getQuestionAndAnswers$(payloadGetquestions)
      .subscribe((res) => {
        this.Questions = res;
        this.displayOrder = this.Questions.some((e) => e.Display_Order);
        this.sortQuestions();
      });
  }

  dragEntered(event: CdkDragEnter<number>) {
    const drag = event.item;
    const dropList = event.container;
    const dragIndex = drag.data;
    const dropIndex = dropList.data;
    this.droppedIndex = dropIndex;
    this.dragDropInfo = { dragIndex, dropIndex };
    console.log('dragEntered', { dragIndex, dropIndex });

    const phContainer = dropList.element.nativeElement;
    const phElement = phContainer.querySelector('.cdk-drag-placeholder');

    if (phElement) {
      phContainer.removeChild(phElement);
      phContainer.parentElement?.insertBefore(phElement, phContainer);

      moveItemInArray(this.Questions, dragIndex, dropIndex);
    }
  }

  dragMoved(event: CdkDragMove<number>) {
    if (!this.dropListContainer || !this.dragDropInfo) return;

    const placeholderElement =
      this.dropListContainer.nativeElement.querySelector(
        '.cdk-drag-placeholder'
      );

    const receiverElement =
      this.dragDropInfo.dragIndex > this.dragDropInfo.dropIndex
        ? placeholderElement?.nextElementSibling
        : placeholderElement?.previousElementSibling;

    if (!receiverElement) {
      return;
    }

    receiverElement.style.display = 'none';
    this.dropListReceiverElement = receiverElement;
    const container = this.dropListContainer.nativeElement;
    const { y } = event.pointerPosition;

    const scrollSpeed = 50; // Increase speed for faster scrolling
    const threshold = 60; // Distance from the edge to trigger scrolling

    // Scroll up
    if (y < container.getBoundingClientRect().top + threshold) {
      container.scrollBy({ top: -scrollSpeed, behavior: 'smooth' });
    }

    // Scroll down
    if (y > container.getBoundingClientRect().bottom - threshold) {
      container.scrollBy({ top: scrollSpeed, behavior: 'smooth' });
    }
  }

  dragDropped(event: CdkDragDrop<number>) {
    if (!this.dropListReceiverElement) {
      return;
    }

    this.dropListReceiverElement.style.removeProperty('display');
    this.dropListReceiverElement = undefined;
    this.dragDropInfo = undefined;
  }

  triggerParentFunction(question: IQuestionsWithAnswersModifiedResponse): void {
    // Emit data to the parent component
    const data = {
      Question_Id: question.Question_ID,
      Questions: this.Questions,
      Subject_Id: this.SubjectId,
    };
    this.openQuestionEdit.emit(data);
  }
  SanitizeHTML(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  isHighlighted(index: number): boolean {
    return index === this.droppedIndex; // Check if the tile should be highlighted
  }

  onSave() {
    const questionArray = this.Questions.map((element, index) => {
      return { QuestionID: element.Question_ID, DisplayOrder: index + 1 };
    });
    this.questionService.updateQuestionDisplayOrder$(questionArray).subscribe(
      (res) => {
            this.toaster.success('Saved Successfully', 'Success', {
              timeOut: ConstantVars.ToastSucessTimeout,
            });
        this.droppedIndex = null;
        this.getQuestionsAndAnswers();
      },
      (error) => {
        this.toaster.error(error.error.Message || 'Something went wrong', '', {
          timeOut: ConstantVars.ToastErrorTimeout,
        });
      }
    );
  }
  onCross() {
    this.activeModal.close(false);
  }
}
